/**
 * @deprecated - Legacy iframe-based SMP component.
 * Replaced by SMPLandingPage.tsx with native React UI.
 * Kept for reference during migration.
 */
import TokenManager from '@viome/viome-base/src/api/TokenManager';
import environment from '@config/environment';
import { Loader } from '@design-system/Loader';
import { useState } from 'react';

export const SMPLegacy = () => {
  const [span] = useState(() => Date.now().valueOf());
  const OLD_SMP_PAGE_URL = `${environment.OLD_BASE_URL}/more/manage-subscriptions?in_iframe=true&span=${span}&token=${TokenManager.getAuthToken()}`;
  const IFRAME_HEIGHT = '100%';
  const IFRAME_WIDTH = '100%';
  const [iframeLoading, setIframeLoading] = useState(true);

  return (
    <div>
      {iframeLoading && (
        <Loader />
      )}
      <iframe
        src={OLD_SMP_PAGE_URL}
        height={IFRAME_HEIGHT}
        width={IFRAME_WIDTH}
        style={{ height: '100vh' }}
        frameBorder="0"
        allowFullScreen
        onLoad={() => setIframeLoading(false)}
      />
    </div>
  );
};
